'use strict'

const FETCH_VERSION_REQUEST = "FETCH_VERSION_REQUEST";
const FETCH_VERSION_REQUEST_SUCCESS = "FETCH_VERSION_REQUEST_SUCCESS";
const FETCH_VERSION_REQUEST_FAILURE = "FETCH_VERSION_REQUEST_FAILURE";

export {
    FETCH_VERSION_REQUEST,
    FETCH_VERSION_REQUEST_SUCCESS,
    FETCH_VERSION_REQUEST_FAILURE
}